import type { DepositRow, DepositSummary } from "@opulancia/deposit-core";
import { h } from "../dom.js";

/** The three statuses, never merged into one: upload, integrity, analysis. */
export function uploadChip(d: DepositSummary): HTMLElement {
  return d.upload_status === "complete" ? h("span", { class: "chip ok" }, "Enregistré") : h("span", { class: "chip warn" }, "Envoi inachevé");
}

export function integrityChip(d: DepositSummary): HTMLElement | null {
  if (d.upload_status !== "complete") return null;
  if (d.integrity_status === "verified") return h("span", { class: "chip ok" }, "Intégrité vérifiée");
  if (d.integrity_status === "failed") return h("span", { class: "chip bad" }, "Intégrité en échec");
  return h("span", { class: "chip" }, "Intégrité à vérifier");
}

export function instagramChip(d: DepositRow): HTMLElement | null {
  return d.instagram_url ? h("span", { class: "chip yellow" }, "Instagram") : null;
}

export const ANALYSIS: Record<DepositSummary["analysis_status"], string> = {
  not_analyzed: "Non analysé",
  analyzed: "Analysé",
  failed: "Analyse en échec",
};

export const EVENTS: Record<string, string> = {
  started: "Dépôt commencé",
  resumed: "Envoi repris",
  completed: "Enregistré — chaque fichier confirmé par le serveur",
  order_changed: "Ordre modifié",
  instagram_linked: "Lien Instagram ajouté",
  instagram_unlinked: "Lien Instagram retiré",
  integrity_verified: "Intégrité vérifiée",
  integrity_failed: "Intégrité en échec",
};
